<template>
	<div class="template_input">
		<label v-bind:for="params.name">{{getLabel(params.label)}} <span v-if="params.compulsory" class="star">*</span>:</label>
		<input type="text" v-bind:id="params.name" v-bind:placeholder="getLabel(params.label)" v-model="value" autocomplete="off" v-on:click="scrollToThisInput" pattern=".*">

	</div>
</template>

<script>

import componentTools from '@/libs/componentTools.js';
import lib from '@/libs/main.js';

export default {
	name: 'text2_input',
	data() {
		return {
			value : ''
		}
	},
	props : ['params', 'oldValue', 'lang'],
	computed : {
	},
	methods : {
		validate : function(v) {
			return v.trim().length;
		},
		notifyUpdate : function(val) {
			this.$emit('validateField', this.params.name, val);
		},
		getLabel : componentTools.getLabel,
		scrollToThisInput : function(event) {
			if(this.params.scrollTo) return lib.scrollToElem(event.target);
		}
	},
	watch: {
		value : function(val){
			let v = val.trim();
			if(this.validate(v)) this.notifyUpdate(v);
			else this.notifyUpdate();
		},
		oldValue : {
			handler : function(val){
				if(!val) this.value = '';
			},
			deep : true
		}
	},
	mounted : function(){
		if(this.oldValue) this.value = this.oldValue;
	}
};
</script>



// WEBPACK FOOTER //
// src/components/candidate_forms/text2_input.vue